{
  "greeting": "안녕하세요! 오늘 와인에 대해 어떻게 도와드릴까요?",
  "thinking": "✨ 생각 중...",
  "thinkingStep": "✨ 완벽한 와인을 찾고 있습니다…🍷",
  "askAboutWine": "예: 1990년대 보르도 레드 약 $1500 | 부르고뉴 빌라주 화이트 $600 이하",
  "askAboutWineFirst": "구매하고 싶습니다 (지역 + 색상 + 빈티지 + 예산)",
  "waitingForResponse": "응답 대기 중...",
  "dailyLimitReached": "일일 상담 한도에 도달했습니다. HKT 00:00 이후에 다시 방문해 주세요.",
  "chatHistory": "채팅 기록",
  "noChatHistory": "아직 채팅 기록이 없습니다",
  "startConversation": "대화를 시작하면 여기에 표시됩니다",
  "backToChat": "채팅으로 돌아가기",
  "newChat": "새 채팅",
  "history": "기록",
  "search": "검색",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "와인 어드바이저",
  "chat": "채팅",
  "chatNumber": "채팅 {number}",
  "wineRecommended": "와인 {count}개 추천",
  "winesRecommended": "와인 {count}개 추천",
  "justNow": "방금",
  "minuteAgo": "{count}분 전",
  "minutesAgo": "{count}분 전",
  "hourAgo": "{count}시간 전",
  "hoursAgo": "{count}시간 전",
  "dayAgo": "{count}일 전",
  "daysAgo": "{count}일 전",
  "noMessagesYet": "아직 메시지가 없습니다",
  "perBottle": "병당",
  "priceNA": "가격 미정",
  "buyNow": "지금 구매",
  "moreInformation": "더 많은 정보",
  "share": {
    "button": "공유",
    "title": "대화 공유",
    "description": "아래 링크를 사용하여 이 대화를 친구들과 공유하세요:",
    "generating": "공유 링크 생성 중...",
    "error": "공유 링크 생성에 실패했습니다",
    "copy": "복사",
    "copied": "복사됨!",
    "note": "참고: 이 링크는 30일 후에 만료됩니다. 누군가 이 링크를 열면 이 대화의 사본을 볼 수 있습니다."
  },
  "checkOutWine": "이 와인을 확인하세요: {name} {vintage}",
  "linkCopied": "링크가 클립보드에 복사되었습니다!",
  "contactWhatsApp": "더 많은 옵션은 WhatsApp으로 문의하세요",
  "errorLoadingWine": "죄송합니다. 와인 상세 정보를 불러올 수 없었습니다.",
  "errorOccurred": "응답을 가져오는 중 오류가 발생했습니다.",
  "you": "나",
  "welcome": {
    "intro": "WWX에 오신 것을 환영합니다. AI 와인 어드바이저 Zyra입니다. 다음에 접근할 수 있습니다:",
    "features": {
      "globalMarket": "글로벌 파인 와인 시장 (UK, FR, HK 판매자)",
      "realTimeOffers": "예산 내 실시간 베스트 오퍼",
      "personalized": "나만을 위한 맞춤 추천",
      "comparison": "빈티지 및 브랜드 간편 비교",
      "instantCheckout": "즉시 수량 및 배송 결제"
    },
    "question": "오늘 무엇을 추천해 드릴까요?",
    "trendingPrompts": "질문 예시",
    "promptExamples": {
      "title": "질문하는 방법:",
      "good": "✓ 좋은 예시:",
      "bad": "✗ 예산 없는 질문은 피하세요:"
    },
    "prompts": {
      "bordeaux": "보르도 레드 약 $800",
      "champagne": "그로워 샴페인 $2000 이하",
      "firstGrowth": "퍼스트 그로스 2010-2019 베스트 오퍼"
    }
  },
  "feedback": {
    "helpful": "도움이 되었습니다",
    "notHelpful": "도움이 되지 않았습니다",
    "thankYou": "피드백 감사합니다!",
    "whatDidYouLike": "어떤 점이 좋았나요?",
    "whatCouldBeImproved": "어떤 점이 개선될 수 있을까요?",
    "category": "카테고리",
    "selectCategory": "카테고리 선택",
    "categories": {
      "accuracy": "정확성",
      "helpfulness": "유용성",
      "responseSpeed": "응답 속도",
      "clarity": "명확성",
      "other": "기타"
    },
    "comments": "의견",
    "placeholder": "경험에 대해 더 알려주세요...",
    "cancel": "취소",
    "submit": "피드백 제출",
    "submitting": "제출 중..."
  },
  "auth": {
    "limitReached": "일일 한도 도달",
    "signUpToday": "더 많은 메시지를 위해 가입하세요",
    "limitMessage": "일일 메시지 한도에 도달했습니다. 무료 계정에 가입하여 채팅을 계속하세요.",
    "benefitsMessage": "무료 계정을 만들어 채팅을 계속하고 모든 기기에서 채팅 기록을 저장하세요.",
    "remainingMessages": "오늘 {count}개의 메시지가 남아있습니다",
    "signUp": "가입",
    "login": "로그인",
    "loggedInAs": "{email}로 로그인됨",
    "logout": "로그아웃"
  }
}
